/**
 * Utility functions for client data handling
 */

/**
 * Get full name from a client object
 * @param {Object} client - Client object with name and last_name fields
 * @returns {string} Full name (first name + last name)
 */
export const getFullName = (client) => {
	if (!client) return ''
	const firstName = client.name || ''
	const lastName = client.last_name || ''
	return `${firstName} ${lastName}`.trim()
}

/**
 * Get full name from separate first and last name values
 * @param {string} firstName - First name
 * @param {string} lastName - Last name
 * @returns {string} Full name
 */
export const buildFullName = (firstName, lastName) => {
	const first = firstName || ''
	const last = lastName || ''
	return `${first} ${last}`.trim()
}

